import type { MutationTree } from "vuex";

import type { ConfigState } from "./state";

import type { SpinProps } from "ant-design-vue";

import { ConfigMutationTypes } from "./mutation-types";

export type Mutations<S = ConfigState> = {
  [ConfigMutationTypes.SET_SPIN_CONFIG](
    state: S,
    payload: ConfigState["spinConfig"]
  ): void;
  [ConfigMutationTypes.SET_ENCRYPTION_CONFIG](
    state: S,
    payload: Partial<ConfigState["encryptionConfig"]>
  ): void;
  [ConfigMutationTypes.RESET_ENCRYPTION_CONFIG](state: S): void;
  [ConfigMutationTypes.SET_TRUST_CONFIG](
    state: S,
    payload: Partial<ConfigState["trustConfig"]>
  ): void;
  [ConfigMutationTypes.SET_PUBLISH_DATA_CONFIG](
    state: S,
    payload: Partial<ConfigState["publishDataConfig"]>
  ): void;
  [ConfigMutationTypes.SET_PUBLISH_API_DATA_CONFIG](
    state: S,
    payload: Partial<ConfigState["publishAPIDataConfig"]>
  ): void;
};

export const mutations: MutationTree<ConfigState> & Mutations = {
  [ConfigMutationTypes.SET_SPIN_CONFIG](state, payload) {
    const defaultConfig: SpinProps = {
      spinning: false,
      tip: "Loading...",
      size: "large",
    };
    state.spinConfig = {
      ...defaultConfig,
      ...payload,
    };
  },
  [ConfigMutationTypes.SET_ENCRYPTION_CONFIG](state, payload) {
    state.encryptionConfig = {
      ...state.encryptionConfig,
      ...payload,
    };
  },
  [ConfigMutationTypes.RESET_ENCRYPTION_CONFIG](state) {
    state.encryptionConfig = {
      privateKey: "",
      publicKey: "",
      metaKeyFileName: "",
      isDownloadFile: false,
    };
  },
  [ConfigMutationTypes.SET_TRUST_CONFIG](state, payload) {
    state.trustConfig = {
      ...state.trustConfig,
      ...payload,
    };
  },
  [ConfigMutationTypes.SET_PUBLISH_DATA_CONFIG](state, payload) {
    state.publishDataConfig = {
      ...state.publishDataConfig,
      ...payload,
    };
  },
  [ConfigMutationTypes.SET_PUBLISH_API_DATA_CONFIG](state, payload) {
    state.publishAPIDataConfig = {
      ...state.publishAPIDataConfig,
      ...payload,
    };
  },
};
